export const createLegacyUrl = (path: string, customerExternalId: string) =>
  `/console/lui${path}?frameless=true&customer_external_id=${customerExternalId}`;
